import { Theme } from '@mui/material';
import { SystemProps } from '@mui/system';

const fontSize = (dense: boolean) => (dense ? '12px' : '16px');

export const inputFontStyle = (theme: Theme, dense: boolean) => ({
  fontSize: fontSize(dense),
  fontWeight: '400',
  lineHeight: '150%',
  color: theme.palette.primary[80],
});

export const headerStyle = (theme: Theme, selectedCount: number) => {
  return {
    '.MuiFormControl-root': {
      margin: '0',
    },
    ...(selectedCount > 0
      ? {
          alignItems: 'center',
          padding: '9px 24px 9px',
          gap: '48px',
          borderRadius: '4px',
          background: theme.palette.primary[20],
        }
      : {
          minHeight: '49px',
        }),
  };
};

export const containerStyle: SystemProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
};

export const additionalFiltersStyle = {
  '&&': { marginTop: '8px' },
  marginBottom: 0,
};

export const searchFieldStyle = {
  width: '260px',
  ...additionalFiltersStyle,
};

export const selectBoxStyle = (theme: Theme, dense: boolean) => ({
  maxWidth: '200px',
  '.MuiInputBase-root': {
    padding: '0',
    height: '31px',
    '.Mui-placeholder': {
      ...inputFontStyle(theme, dense),
    },
    '.MuiSelect-select': {
      ...inputFontStyle(theme, dense),
    },
  },
});

export const actionsBoxStyle = {
  '> div': {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    '> *, > div.MuiFormControl-root': {
      marginLeft: '10px',
    },
  },
};
